import { ValueProvider } from '@angular/core';
import { SkyproConfig } from './const';
import { getBaseConfig } from './utils';

export function provideSkyproBaseConfig(rootDomain: string): ValueProvider {
  const config = getBaseConfig(rootDomain);
  return { provide: SkyproConfig, useValue: config };
}
